// //try1
// import React, { useState, useEffect } from "react";
// import apiService from "../config";
// // top of Reports.js  ─ add after the existing imports
// // import { generateHearingNoticePDF } from "../Pages/HearingNotice";
// // import { generateCompensationPDF }   from "../Pages/CompensationNotice";
// // import { generateJmrPDF }           from "../Pages/JmrReport";
// import { generateAnushuchiOnePDF } from "../Pages/Anushuchi1"; // Use the Marathi version
// import FinalAwardNotice from "../Pages/FinalAwardNotice"; // Importing FinalAwardNotice

// const reportTypes = [
//   "Compensation - Kalam 37 (2)",
//   "Final Awards - Taba Pavti",
//   "Hearing Notice - Form V",
//   "Prathmik Adhisuchna - Anushuchi 1",
//   "Anushuchi 1 Kalam 19",
//   "JMR",
//   // "Praman Patra",
// ];

// const Reports = () => {
//   const [currentProjectId, setCurrentProjectId] = useState(null);
//   const [districts, setDistricts] = useState([]);
//   const [talukas, setTalukas] = useState([]);
//   const [villages, setVillages] = useState([]);
//   const [selectedDistrict, setSelectedDistrict] = useState("");
//   const [selectedTaluka, setSelectedTaluka] = useState("");
//   const [selectedVillage, setSelectedVillage] = useState("");
//   const [selectedReportType, setSelectedReportType] = useState("");
//   const [previewUrl, setPreviewUrl] = useState(null);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [landowners, setLandowners] = useState([]); // To hold the landowners data
//   const [isLoading, setIsLoading] = useState(false); // Loading state

//   useEffect(() => {
//     // Fetch current project info from localStorage
//     const getProjectInfo = () => {
//       const raw = localStorage.getItem("currentProjectData");
//       if (raw) {
//         try {
//           const obj = JSON.parse(raw);
//           return { id: obj.project_id, name: obj.project_name };
//         } catch (e) {
//           console.error(`Error parsing currentProjectData:`, e);
//         }
//       }
//       return { id: null, name: null };
//     };
//     const info = getProjectInfo();
//     setCurrentProjectId(info.id);
//   }, []);

//   useEffect(() => {
//     const fetchDistricts = async () => {
//       try {
//         const res = await apiService.getDistricts();
//         setDistricts(res.data || []);
//       } catch (error) {
//         console.error("Error fetching districts:", error);
//         setErrorMessage("Failed to fetch districts");
//       }
//     };
//     fetchDistricts();
//   }, []);

//   useEffect(() => {
//     const fetchTalukas = async () => {
//       if (selectedDistrict) {
//         try {
//           const res = await apiService.getTalukas(selectedDistrict);
//           setTalukas(res.data || []);
//         } catch (error) {
//           console.error("Error fetching talukas:", error);
//           setErrorMessage("Failed to fetch talukas");
//         }
//       } else {
//         setTalukas([]);
//       }
//     };
//     fetchTalukas();
//   }, [selectedDistrict]);

//   useEffect(() => {
//     const fetchVillages = async () => {
//       if (selectedDistrict && selectedTaluka) {
//         try {
//           const res = await apiService.getVillages(selectedDistrict, selectedTaluka);
//           setVillages(res.data || []);
//         } catch (error) {
//           console.error("Error fetching villages:", error);
//           setErrorMessage("Failed to fetch villages");
//         }
//       } else {
//         setVillages([]);
//       }
//     };
//     fetchVillages();
//   }, [selectedDistrict, selectedTaluka]);

//   // // Fetch landowners data based on selected criteria
//   // const fetchLandowners = async () => {
//   //   try {
//   //     const params = {
//   //       projectId: currentProjectId,
//   //       districtId: selectedDistrict,
//   //       talukaId: selectedTaluka,
//   //       villageId: selectedVillage,
//   //     };
      
//   //     // You'll need to replace this with your actual API call to get landowners
//   //     // This is a placeholder - adjust according to your API structure
//   //     const response = await apiService.getLandowners(params);
      
//   //     setLandowners(response.data || []);
//   //     return response.data || [];
//   //   } catch (error) {
//   //     console.error("Error fetching landowners:", error);
//   //     setErrorMessage("Failed to fetch landowners data");
//   //     return [];
//   //   }
//   // };
//   // --- put this inside Reports.js, replacing the old fetchLandowners --- //
// /**
//  * Returns a normalised array of land‑owner records for the
//  * currently‑selected district/taluka/village & report type.
//  */

// const fetchLandowners = async () => {
//   try {
//     const params = {
//       projectId: currentProjectId,
//       districtId: selectedDistrict,
//       talukaId: selectedTaluka,
//       villageId: selectedVillage,
//     };

//     let response;          // raw API response (could be array or object)
//     let landownersData=[]; // final, normalised array we'll return

//     /* ------------------------------------------------------------------
//        1️⃣  Pick the right endpoint for the chosen report type
//     ------------------------------------------------------------------ */
//     switch (selectedReportType) {
//       case "Prathmik Adhisuchna - Anushuchi 1":
//         //  ‑ existing call you already had
//         response = await apiService.getLandowners(params);
//         break;

//       case "Final Awards - Taba Pavti":
//         //  ‑ new Final‑Award‑specific endpoint you pasted
//         response = await apiService.getFinalAward(
//           params.projectId,
//           params.districtId,
//           params.talukaId,
//           params.villageId
//         );
//         break;

//       /* ----‑‑‑‑ add more report‑type cases here as you wire up ---- */
//       case "Hearing Notice - Form V":
//         response = await apiService.getHearing(params);
//         break;
//       case "JMR":
//         response = await apiService.getMeasurementByLandId(params);
//         break;
//       case "Compensation - Kalam 37 (2)":
//         response = await apiService.getLandHolding(
//        params.projectId,
//           params.districtId,
//           params.talukaId,
//           params.villageId
//     );

//         break;
//       /* ----------------------------------------------------------- */

//       default:
//         throw new Error(
//           `No API mapping for report type “${selectedReportType}”`
//         );
//     }

//     /* ------------------------------------------------------------------
//        2️⃣  Normalise whatever came back into a *flat array*
//            – covers all the shapes you saw in your console logs.
//     ------------------------------------------------------------------ */
//     if (Array.isArray(response)) {
//       landownersData = response;
//     } else if (response?.data) {
//       if (Array.isArray(response.data)) {
//         landownersData = response.data;
//       } else if (Array.isArray(response.data.landowners)) {
//         landownersData = response.data.landowners;
//       } else if (Array.isArray(response.data.data)) {
//         landownersData = response.data.data;
//       }
//     }

//     /* ------------------------------------------------------------------
//        3️⃣  Update state & return
//     ------------------------------------------------------------------ */
//     setLandowners(landownersData);
//     return landownersData;
//   } catch (error) {
//     console.error("Error fetching landowners:", error);
//     setErrorMessage("Failed to fetch landowners data: " + error.message);
//     return [];
//   }
// };


//   const handlePreview = async () => {
//     console.log("Preview button clicked");
//     setPreviewUrl(null);
//     setErrorMessage("");
//     setIsLoading(true);
    
//     const params = {
//       projectId: currentProjectId,
//       districtId: selectedDistrict,
//       talukaId: selectedTaluka,
//       villageId: selectedVillage,
//     };

//     console.log("Preview params:", params);

//     try {
//       if (selectedReportType === "Prathmik Adhisuchna - Anushuchi 1") {
//         console.log("Starting Anushuchi 1 PDF generation...");
//         console.log("Parameters:", params);
        
//         // Generate Anushuchi 1 PDF preview
//         const blobUrl = await generateAnushuchiOnePDF(params, true);
//         console.log("Generated blob URL:", blobUrl);
        
//         if (typeof blobUrl === "string" && blobUrl.startsWith("blob:")) {
//           setPreviewUrl(blobUrl);
//           console.log("Preview URL set successfully");
//         } else {
//           console.error("Invalid blob URL received:", blobUrl);
//           setErrorMessage("Failed to generate preview. Invalid response format.");
//         }
//       } else if (selectedReportType === "Final Awards - Taba Pavti") {
//         // Fetch landowners data first
//         const landownersData = await fetchLandowners();
//         if (landownersData.length === 0) {
//           setErrorMessage("No landowner data found for the selected criteria.");
//           return;
//         }
        
//         // For preview, we'll create a temporary container and show the first landowner's HTML
//         const firstLandowner = landownersData[0];
//         const htmlContent = FinalAwardNotice.renderHTML(firstLandowner);
        
//         // Create a blob URL for preview
//         const blob = new Blob([`
//           <!DOCTYPE html>
//           <html>
//           <head>
//             <meta charset="UTF-8">
//             <title>Final Award Notice Preview</title>
//             <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;700&display=swap" rel="stylesheet">
//           </head>
//           <body>
//             ${htmlContent}
//           </body>
//           </html>
//         `], { type: 'text/html' });
        
//         const blobUrl = URL.createObjectURL(blob);
//         setPreviewUrl(blobUrl);
//       } else {
//         // Handle other report types
//         try {
//           const response = await apiService.generateReport(selectedReportType, params);
//           if (response.data && response.data.previewUrl) {
//             setPreviewUrl(response.data.previewUrl);
//           } else {
//             setErrorMessage("Preview not available for this report type");
//           }
//         } catch (error) {
//           console.error("Error generating other report preview:", error);
//           setErrorMessage("Preview not available for this report type");
//         }
//       }
//     } catch (error) {
//       console.error("Error generating preview:", error);
//       setErrorMessage(`Failed to generate preview: ${error.message}`);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleDownload = async () => {
//     console.log("Download button clicked");
//     setErrorMessage("");
//     setIsLoading(true);
    
//     const params = {
//       projectId: currentProjectId,
//       districtId: selectedDistrict,
//       talukaId: selectedTaluka,
//       villageId: selectedVillage,
//     };

//     console.log("Download params:", params);

//     try {
//       if (selectedReportType === "Prathmik Adhisuchna - Anushuchi 1") {
//         console.log("Starting Anushuchi 1 PDF download...");
//         console.log("Parameters:", params);
        
//         // Generate and download Anushuchi 1 PDF
//         const result = await generateAnushuchiOnePDF(params, false);
//         console.log("Download result:", result);
        
//         if (result === true) {
//           console.log("PDF downloaded successfully");
//         } else {
//           console.error("Download failed:", result);
//           setErrorMessage("Failed to download PDF");
//         }
//       } else if (selectedReportType === "Final Awards - Taba Pavti") {
//         // Fetch landowners data and generate individual PDFs
//         const landownersData = await fetchLandowners();
//         if (landownersData.length === 0) {
//           setErrorMessage("No landowner data found for the selected criteria.");
//           return;
//         }
        
//         // Generate PDF for each landowner
//         for (const landowner of landownersData) {
//           await FinalAwardNotice.generatePDF(landowner);
//         }
        
//         alert(`Generated ${landownersData.length} Final Award Notice(s)`);
//       } else if (selectedReportType === "Hearing Notice - Form V") {
//   //   // 👉 download Hearing Notice
//   //   await generateHearingNoticePDF(params);
//   //   alert("Hearing Notice PDF generated ✔");

//   // } else if (selectedReportType === "JMR") {
//   //   // 👉 download Joint Measurement Report
//   //   await generateJmrPDF(params);
//   //   alert("JMR PDF generated ✔");

//   // } else if (selectedReportType === "Compensation - Kalam 37 (2)") {
//   //   // 👉 download Compensation Notice
//   //   await generateCompensationPDF(params);
//   //   alert("Compensation Notice PDF generated ✔");

//   } 
//   else {

//         // Handle other report types
//         try {
//           const response = await apiService.downloadReport(selectedReportType, params);
          
//           // Create download link
//           const url = window.URL.createObjectURL(new Blob([response.data]));
//           const link = document.createElement('a');
//           link.href = url;
//           link.setAttribute('download', `${selectedReportType}_${Date.now()}.pdf`);
//           document.body.appendChild(link);
//           link.click();
//           link.remove();
//           window.URL.revokeObjectURL(url);
//         } catch (error) {
//           console.error("Error downloading other report:", error);
//           setErrorMessage("Download not available for this report type");
//         }
//       }
//     } catch (error) {
//       console.error("Error downloading report:", error);
//       setErrorMessage(`Failed to download report: ${error.message}`);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleReset = () => {
//     setSelectedDistrict("");
//     setSelectedTaluka("");
//     setSelectedVillage("");
//     setSelectedReportType("");
//     setPreviewUrl(null);
//     setErrorMessage("");
//     setLandowners([]);
//   };

//   const isFormValid = () => {
//     return currentProjectId && selectedDistrict && selectedTaluka && selectedVillage && selectedReportType;
//   };

//   const closePreview = () => {
//     if (previewUrl) {
//       URL.revokeObjectURL(previewUrl);
//     }
//     setPreviewUrl(null);
//   };

//   return (
//     <div className="reports-container">
//       <div className="reports-header">
//         <h2>Reports Generation</h2>
//         <p>Generate various reports for land acquisition projects</p>
//       </div>

//       <div className="reports-form">
//         <div className="form-row">
//           <div className="form-group">
//             <label htmlFor="district">District *</label>
//             <select
//               id="district"
//               value={selectedDistrict}
//               onChange={(e) => {
//                 setSelectedDistrict(e.target.value);
//                 setSelectedTaluka("");
//                 setSelectedVillage("");
//               }}
//               disabled={!districts.length}
//             >
//               <option value="">Select District</option>
//               {districts.map((district) => (
//                 <option key={district.id} value={district.id}>
//                   {district.dist_name}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className="form-group">
//             <label htmlFor="taluka">Taluka *</label>
//             <select
//               id="taluka"
//               value={selectedTaluka}
//               onChange={(e) => {
//                 setSelectedTaluka(e.target.value);
//                 setSelectedVillage("");
//               }}
//               disabled={!selectedDistrict || !talukas.length}
//             >
//               <option value="">Select Taluka</option>
//               {talukas.map((taluka) => (
//                 <option key={taluka.id} value={taluka.id}>
//                   {taluka.taluka_name}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className="form-group">
//             <label htmlFor="village">Village *</label>
//             <select
//               id="village"
//               value={selectedVillage}
//               onChange={(e) => setSelectedVillage(e.target.value)}
//               disabled={!selectedTaluka || !villages.length}
//             >
//               <option value="">Select Village</option>
//               {villages.map((village) => (
//                 <option key={village.id} value={village.id}>
//                   {village.village_name}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>

//         <div className="form-row">
//           <div className="form-group">
//             <label htmlFor="reportType">Report Type *</label>
//             <select
//               id="reportType"
//               value={selectedReportType}
//               onChange={(e) => setSelectedReportType(e.target.value)}
//             >
//               <option value="">Select Report Type</option>
//               {reportTypes.map((type) => (
//                 <option key={type} value={type}>
//                   {type}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>

//         {errorMessage && (
//           <div className="error-message">
//             <p>{errorMessage}</p>
//           </div>
//         )}

//         <div className="form-actions">
//           <button
//             type="button"
//             onClick={handlePreview}
//             disabled={!isFormValid() || isLoading}
//             className="btn btn-secondary"
//           >
//             {isLoading ? "Generating..." : "Preview"}
//           </button>
          
//           <button
//             type="button"
//             onClick={handleDownload}
//             disabled={!isFormValid() || isLoading}
//             className="btn btn-primary"
//           >
//             {isLoading ? "Downloading..." : "Download"}
//           </button>
          
//           <button
//             type="button"
//             onClick={handleReset}
//             className="btn btn-outline"
//             disabled={isLoading}
//           >
//             Reset
//           </button>
//         </div>
//       </div>

//       {previewUrl && (
//         <div className="preview-container">
//           <div className="preview-header">
//             <h3>Report Preview</h3>
//             <button
//               onClick={closePreview}
//               className="btn btn-small"
//             >
//               Close Preview
//             </button>
//           </div>
//           <div className="preview-frame">
//             <iframe
//               src={previewUrl}
//               width="100%"
//               height="600px"
//               title="Report Preview"
//               frameBorder="0"
//             />
//           </div>
//         </div>
//       )}

//       <style jsx>{`
//         .reports-container {
//           max-width: 1200px;
//           margin: 0 auto;
//           padding: 20px;
//         }

//         .reports-header {
//           margin-bottom: 30px;
//           text-align: center;
//         }

//         .reports-header h2 {
//           color: #333;
//           margin-bottom: 10px;
//         }

//         .reports-header p {
//           color: #666;
//           font-size: 14px;
//         }

//         .reports-form {
//           background: #fff;
//           padding: 30px;
//           border-radius: 8px;
//           box-shadow: 0 2px 10px rgba(0,0,0,0.1);
//           margin-bottom: 30px;
//         }

//         .form-row {
//           display: flex;
//           gap: 20px;
//           margin-bottom: 20px;
//         }

//         .form-group {
//           flex: 1;
//         }

//         .form-group label {
//           display: block;
//           margin-bottom: 5px;
//           font-weight: 500;
//           color: #333;
//         }

//         .form-group select {
//           width: 100%;
//           padding: 10px;
//           border: 1px solid #ddd;
//           border-radius: 4px;
//           font-size: 14px;
//         }

//         .form-group select:disabled {
//           background-color: #f5f5f5;
//           cursor: not-allowed;
//         }

//         .error-message {
//           background-color: #fee;
//           border: 1px solid #fcc;
//           color: #c33;
//           padding: 10px;
//           border-radius: 4px;
//           margin-bottom: 20px;
//         }

//         .form-actions {
//           display: flex;
//           gap: 15px;
//           justify-content: center;
//           margin-top: 30px;
//         }

//         .btn {
//           padding: 12px 24px;
//           border: none;
//           border-radius: 4px;
//           cursor: pointer;
//           font-size: 14px;
//           font-weight: 500;
//           transition: all 0.2s;
//         }

//         .btn:disabled {
//           opacity: 0.6;
//           cursor: not-allowed;
//         }

//         .btn-primary {
//           background-color: #007bff;
//           color: white;
//         }

//         .btn-primary:hover:not(:disabled) {
//           background-color: #0056b3;
//         }

//         .btn-secondary {
//           background-color: #6c757d;
//           color: white;
//         }

//         .btn-secondary:hover:not(:disabled) {
//           background-color: #545b62;
//         }

//         .btn-outline {
//           background-color: transparent;
//           color: #6c757d;
//           border: 1px solid #6c757d;
//         }

//         .btn-outline:hover:not(:disabled) {
//           background-color: #6c757d;
//           color: white;
//         }

//         .preview-container {
//           background: #fff;
//           border-radius: 8px;
//           box-shadow: 0 2px 10px rgba(0,0,0,0.1);
//           overflow: hidden;
//         }

//         .preview-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           padding: 20px;
//           background-color: #f8f9fa;
//           border-bottom: 1px solid #dee2e6;
//         }

//         .preview-header h3 {
//           margin: 0;
//           color: #333;
//         }

//         .btn-small {
//           padding: 8px 16px;
//           font-size: 12px;
//         }

//         .preview-frame {
//           padding: 0;
//         }

//         @media (max-width: 768px) {
//           .form-row {
//             flex-direction: column;
//           }
          
//           .form-actions {
//             flex-direction: column;
//           }
          
//           .preview-header {
//             flex-direction: column;
//             gap: 10px;
//             text-align: center;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default Reports;

import React, { useState, useEffect, useCallback, useMemo } from "react";
import apiService from "../config";
// import { generateHearingNoticePDF } from "../Pages/HearingNotice";
import { generateCompensationPDF} from "../Pages/CompensationReport";
import { generateJmrPDF } from "../Pages/JmrReport";
import { generateAnushuchiOnePDF } from "../Pages/Anushuchi1";
import FinalAwardNotice from "../Pages/FinalAwardNotice";
import { useLanguage } from "../StoreContext/LanguageContext";


const reportTypes = [
  "Compensation - Kalam 37 (2)",
  "Final Awards - Taba Pavti",
  // "Hearing Notice - Form V",
  "Prathmik Adhisuchna - Anushuchi 1",
  // "Anushuchi 1 Kalam 19",
  "JMR",
];

const Reports = () => {
  const { language, translations } = useLanguage();
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const [districts, setDistricts] = useState([]);
  const [talukas, setTalukas] = useState([]);
  const [villages, setVillages] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedTaluka, setSelectedTaluka] = useState("");
  const [selectedVillage, setSelectedVillage] = useState("");
  const [selectedReportType, setSelectedReportType] = useState("");
  const [previewUrl, setPreviewUrl] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [landowners, setLandowners] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Memoize project info to prevent unnecessary re-computation
  const projectInfo = useMemo(() => {
    try {
      const raw = localStorage.getItem("currentProjectData");
      if (raw) {
        const obj = JSON.parse(raw);
        return { id: obj.project_id, name: obj.project_name };
      }
    } catch (e) {
      console.error(`Error parsing currentProjectData:`, e);
    }
    return { id: null, name: null };
  }, []);

  // Set project ID only once
  useEffect(() => {
    if (projectInfo.id && projectInfo.id !== currentProjectId) {
      setCurrentProjectId(projectInfo.id);
    }
  }, [projectInfo.id, currentProjectId]);

  // Memoized fetch functions to prevent recreating on every render
  const fetchDistricts = useCallback(async () => {
    try {
      const res = await apiService.getDistricts();
      setDistricts(res.data || []);
    } catch (error) {
      console.error("Error fetching districts:", error);
      setErrorMessage("Failed to fetch districts");
    }
  }, []);

  const fetchTalukas = useCallback(async (districtId) => {
    if (!districtId) {
      setTalukas([]);
      return;
    }
    
    try {
      const res = await apiService.getTalukas(districtId);
      setTalukas(res.data || []);
    } catch (error) {
      console.error("Error fetching talukas:", error);
      setErrorMessage("Failed to fetch talukas");
    }
  }, []);

  const fetchVillages = useCallback(async (districtId, talukaId) => {
    if (!districtId || !talukaId) {
      setVillages([]);
      return;
    }
    
    try {
      const res = await apiService.getVillages(districtId, talukaId);
      setVillages(res.data || []);
    } catch (error) {
      console.error("Error fetching villages:", error);
      setErrorMessage("Failed to fetch villages");
    }
  }, []);

  // Load districts only once on mount
  useEffect(() => {
    fetchDistricts();
  }, [fetchDistricts]);

  // Load talukas when district changes
  useEffect(() => {
    fetchTalukas(selectedDistrict);
    // Reset dependent selections
    if (selectedTaluka) setSelectedTaluka("");
    if (selectedVillage) setSelectedVillage("");
  }, [selectedDistrict, fetchTalukas]);

  // Load villages when district or taluka changes
  useEffect(() => {
    fetchVillages(selectedDistrict, selectedTaluka);
    // Reset village selection
    if (selectedVillage) setSelectedVillage("");
  }, [selectedDistrict, selectedTaluka, fetchVillages]);

  // Optimized landowners fetch function
  const fetchLandowners = useCallback(async () => {
    try {
      const params = {
        projectId: currentProjectId,
        districtId: selectedDistrict,
        talukaId: selectedTaluka,
        villageId: selectedVillage,
      };

      let response;
      let landownersData = [];

      switch (selectedReportType) {
        case "Prathmik Adhisuchna - Anushuchi 1":
          response = await apiService.getLandowners(params);
          break;
        case "Final Awards - Taba Pavti":
          response = await apiService.getFinalAward(
            params.projectId,
            params.districtId,
            params.talukaId,
            params.villageId
          );
          break;
        case "Hearing Notice - Form V":
          response = await apiService.getHearing(params);
          break;
        case "JMR":
          response = await apiService.getMeasurementByLandId(params);
          break;
        case "Compensation - Kalam 37 (2)":
          response = await apiService.getLandHolding(
            params.projectId,
            params.districtId,
            params.talukaId,
            params.villageId
          );
          break;
        default:
          throw new Error(
            `No API mapping for report type "${selectedReportType}"`
          );
      }

      // Normalize response data
      if (Array.isArray(response)) {
        landownersData = response;
      } else if (response?.data) {
        if (Array.isArray(response.data)) {
          landownersData = response.data;
        } else if (Array.isArray(response.data.landowners)) {
          landownersData = response.data.landowners;
        } else if (Array.isArray(response.data.data)) {
          landownersData = response.data.data;
        }
      }

      setLandowners(landownersData);
      return landownersData;
    } catch (error) {
      console.error("Error fetching landowners:", error);
      setErrorMessage("Failed to fetch landowners data: " + error.message);
      return [];
    }
  }, [currentProjectId, selectedDistrict, selectedTaluka, selectedVillage, selectedReportType]);

  // Debounced preview function to prevent rapid successive calls
  const handlePreview = useCallback(async () => {
    if (isLoading) return; // Prevent multiple simultaneous calls
    
    setPreviewUrl(null);
    setErrorMessage("");
    setIsLoading(true);
    
    const params = {
      projectId: currentProjectId,
      districtId: selectedDistrict,
      talukaId: selectedTaluka,
      villageId: selectedVillage,
    };

    try {
      let blobUrl;
      
      switch (selectedReportType) {
        case "Prathmik Adhisuchna - Anushuchi 1":
          blobUrl = await generateAnushuchiOnePDF(params, true);
          break;
        case "Final Awards - Taba Pavti":
          const landownersData = await fetchLandowners();
          if (landownersData.length === 0) {
            setErrorMessage("No landowner data found for the selected criteria.");
            return;
          }
          
          const firstLandowner = landownersData[0];
          const htmlContent = FinalAwardNotice.renderHTML(firstLandowner);
          
          const blob = new Blob([`
            <!DOCTYPE html>
            <html>
            <head>
              <meta charset="UTF-8">
              <title>Final Award Notice Preview</title>
              <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;700&display=swap" rel="stylesheet">
            </head>
            <body>
              ${htmlContent}
            </body>
            </html>
          `], { type: 'text/html' });
          
          blobUrl = URL.createObjectURL(blob);
          break;
        // case "Hearing Notice - Form V":
        //   // blobUrl = await generateHearingNoticePDF(params, true);
        //   break;
        case "JMR":
          blobUrl = await generateJmrPDF(params, true);
          break;
        case "Compensation - Kalam 37 (2)":
          blobUrl = await generateCompensationPDF(params, true);
          break;
        default:
          const response = await apiService.generateReport(selectedReportType, params);
          if (response.data && response.data.previewUrl) {
            blobUrl = response.data.previewUrl;
          } else {
            setErrorMessage("Preview not available for this report type");
            return;
          }
      }
      
      if (typeof blobUrl === "string" && blobUrl.startsWith("blob:")) {
        setPreviewUrl(blobUrl);
      } else {
        setErrorMessage("Failed to generate preview. Invalid response format.");
      }
    } catch (error) {
      console.error("Error generating preview:", error);
      setErrorMessage(`Failed to generate preview: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  }, [currentProjectId, selectedDistrict, selectedTaluka, selectedVillage, selectedReportType, isLoading, fetchLandowners]);

  // Optimized download function
  const handleDownload = useCallback(async () => {
    if (isLoading) return; // Prevent multiple simultaneous calls
    
    setErrorMessage("");
    setIsLoading(true);
    
    const params = {
      projectId: currentProjectId,
      districtId: selectedDistrict,
      talukaId: selectedTaluka,
      villageId: selectedVillage,
    };

    try {
      switch (selectedReportType) {
        case "Prathmik Adhisuchna - Anushuchi 1":
          const result = await generateAnushuchiOnePDF(params, false);
          if (result === true) {
            alert("Anushuchi 1 PDF generated successfully ✔");
          } else {
            setErrorMessage("Failed to download PDF");
          }
          break;
        case "Final Awards - Taba Pavti":
          const landownersData = await fetchLandowners();
          if (landownersData.length === 0) {
            setErrorMessage("No landowner data found for the selected criteria.");
            return;
          }
          
          if (typeof FinalAwardNotice.downloadAll === 'function') {
            await FinalAwardNotice.downloadAll(landownersData);
          } else {
            for (const landowner of landownersData) {
              await FinalAwardNotice.downloadSingle(landowner);
            }
          }
          alert(`Generated ${landownersData.length} Final Award Notice(s) ✔`);
          break;
        // case "Hearing Notice - Form V":
        //   await generateHearingNoticePDF(params, false);
        //   alert("Hearing Notice PDF generated ✔");
        //   break;
        case "JMR":
          await generateJmrPDF(params, false);
          alert("JMR PDF generated ✔");
          break;
        case "Compensation - Kalam 37 (2)":
          await generateCompensationPDF(params, false);
          alert("Compensation Notice PDF generated ✔");
          break;
        default:
          const response = await apiService.downloadReport(selectedReportType, params);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${selectedReportType}_${Date.now()}.pdf`);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Error downloading report:", error);
      setErrorMessage(`Failed to download report: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  }, [currentProjectId, selectedDistrict, selectedTaluka, selectedVillage, selectedReportType, isLoading, fetchLandowners]);

  const handleReset = useCallback(() => {
    setSelectedDistrict("");
    setSelectedTaluka("");
    setSelectedVillage("");
    setSelectedReportType("");
    setPreviewUrl(null);
    setErrorMessage("");
    setLandowners([]);
  }, []);

  // Memoize form validation
  const isFormValid = useMemo(() => {
    return currentProjectId && selectedDistrict && selectedTaluka && selectedVillage && selectedReportType;
  }, [currentProjectId, selectedDistrict, selectedTaluka, selectedVillage, selectedReportType]);

  const closePreview = useCallback(() => {
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }
    setPreviewUrl(null);
  }, [previewUrl]);

  // Handle district change with proper cleanup
  const handleDistrictChange = useCallback((e) => {
    const newDistrict = e.target.value;
    setSelectedDistrict(newDistrict);
    // These will be handled by useEffect, no need to set here
  }, []);

  // Handle taluka change with proper cleanup
  const handleTalukaChange = useCallback((e) => {
    const newTaluka = e.target.value;
    setSelectedTaluka(newTaluka);
    // Village reset will be handled by useEffect
  }, []);

  return (
    <div className="reports-container">
      <div className="reports-header">
        <h2>{translations[language].ReportsGeneration}</h2>
        <p>{translations[language].ReportsDescription}</p>
      </div>

      <div className="reports-form">
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="district">{translations[language].District} *</label>
            <select
              id="district"
              value={selectedDistrict}
              onChange={handleDistrictChange}
              disabled={!districts.length || isLoading}
            >
              <option value="">{translations[language].SelectDistrict}</option>
              {districts.map((district) => (
                <option key={district.id} value={district.id}>
                  {district.dist_name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="taluka">{translations[language].Taluka} *</label>
            <select
              id="taluka"
              value={selectedTaluka}
              onChange={handleTalukaChange}
              disabled={!selectedDistrict || !talukas.length || isLoading}
            >
              <option value="">{translations[language].SelectTaluka}</option>
              {talukas.map((taluka) => (
                <option key={taluka.id} value={taluka.id}>
                  {taluka.taluka_name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="village">{translations[language].Village} *</label>
            <select
              id="village"
              value={selectedVillage}
              onChange={(e) => setSelectedVillage(e.target.value)}
              disabled={!selectedTaluka || !villages.length || isLoading}
            >
              <option value="">{translations[language].SelectVillage}</option>
              {villages.map((village) => (
                <option key={village.id} value={village.id}>
                  {village.village_name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="reportType">{translations[language].ReportType} *</label>
            <select
              id="reportType"
              value={selectedReportType}
              onChange={(e) => setSelectedReportType(e.target.value)}
              disabled={isLoading}
            >
              <option value="">{translations[language].SelectReportType}</option>
              {reportTypes.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>
        </div>

        {errorMessage && (
          <div className="error-message">
            <p>{errorMessage}</p>
          </div>
        )}

        <div className="form-actions">
          <button
            type="button"
            onClick={handlePreview}
            disabled={!isFormValid || isLoading}
            className="btn btn-secondary"
          >
            {isLoading ?<span>{translations[language].Generating}</span> : <span>{translations[language].Preview}</span>}
          </button>
          
          <button
            type="button"
            onClick={handleDownload}
            disabled={!isFormValid || isLoading}
            className="btn btn-primary"
          >
            {isLoading ? <span>{translations[language].Downloading}</span> : <span>{translations[language].Download}</span>}
          </button>
          
          <button
            type="button"
            onClick={handleReset}
            className="btn btn-outline"
            disabled={isLoading}
          >
            {translations[language].Reset}
          </button>
        </div>
      </div>

      {previewUrl && (
        <div className="preview-container">
          <div className="preview-header">
            <h3>{translations[language].ReportPreview}</h3>
            <button
              onClick={closePreview}
              className="btn btn-small"
              disabled={isLoading}
            >
              {translations[language].ClosePreview}
            </button>
          </div>
          <div className="preview-frame">
            <iframe
              src={previewUrl}
              width="100%"
              height="600px"
              title="Report Preview"
              frameBorder="0"
            />
          </div>
        </div>
      )}

      <style jsx>{`
        .reports-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 20px;
        }

        .reports-header {
          margin-bottom: 30px;
          text-align: center;
        }

        .reports-header h2 {
          color: #333;
          margin-bottom: 10px;
        }

        .reports-header p {
          color: #666;
          font-size: 14px;
        }

        .reports-form {
          background: #fff;
          padding: 30px;
          border-radius: 8px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          margin-bottom: 30px;
        }

        .form-row {
          display: flex;
          gap: 20px;
          margin-bottom: 20px;
        }

        .form-group {
          flex: 1;
        }

        .form-group label {
          display: block;
          margin-bottom: 5px;
          font-weight: 500;
          color: #333;
        }

        .form-group select {
          width: 100%;
          padding: 10px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 14px;
        }

        .form-group select:disabled {
          background-color: #f5f5f5;
          cursor: not-allowed;
        }

        .error-message {
          background-color: #fee;
          border: 1px solid #fcc;
          color: #c33;
          padding: 10px;
          border-radius: 4px;
          margin-bottom: 20px;
        }

        .form-actions {
          display: flex;
          gap: 15px;
          justify-content: center;
          margin-top: 30px;
        }

        .btn {
          padding: 12px 24px;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
          transition: all 0.2s;
        }

        .btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .btn-primary {
          background-color: #007bff;
          color: white;
        }

        .btn-primary:hover:not(:disabled) {
          background-color: #0056b3;
        }

        .btn-secondary {
          background-color: #6c757d;
          color: white;
        }

        .btn-secondary:hover:not(:disabled) {
          background-color: #545b62;
        }

        .btn-outline {
          background-color: transparent;
          color: #6c757d;
          border: 1px solid #6c757d;
        }

        .btn-outline:hover:not(:disabled) {
          background-color: #6c757d;
          color: white;
        }

        .preview-container {
          background: #fff;
          border-radius: 8px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          overflow: hidden;
        }

        .preview-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px;
          background-color: #f8f9fa;
          border-bottom: 1px solid #dee2e6;
        }

        .preview-header h3 {
          margin: 0;
          color: #333;
        }

        .btn-small {
          padding: 8px 16px;
          font-size: 12px;
        }

        .preview-frame {
          padding: 0;
        }

        @media (max-width: 768px) {
          .form-row {
            flex-direction: column;
          }
          
          .form-actions {
            flex-direction: column;
          }
          
          .preview-header {
            flex-direction: column;
            gap: 10px;
            text-align: center;
          }
        }
      `}</style>
    </div>
  );
};

export default Reports;